function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.70285 16.695L9.7542 14.3031C9.90653 14.2132 10 14.0495 10 13.8726V3.40983C10 2.86729 9.25712 2.71315 9.04127 3.21091L7.67343 6.36528C7.60098 6.53236 7.44342 6.64683 7.26213 6.66411L2.58834 7.10947C2.15275 7.15098 1.97683 7.69241 2.30483 7.98202L5.82423 11.0895C5.96074 11.21 6.02092 11.3953 5.98133 11.573L4.96061 16.1557C4.86548 16.5828 5.32606 16.9174 5.70285 16.695Z",
  stroke: "black"
});

var SvgStarHalf = function SvgStarHalf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStarHalf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star-half.1d702f8f.svg";
export { ForwardRef as ReactComponent };